import { type VariantProps, cva } from "class-variance-authority";

export { default as Badge } from "./Badge.vue";

export const badgeVariants = cva(
    "inline-flex items-center rounded-full border border-stone-200 px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-stone-950 focus:ring-offset-2 dark:border-stone-800 dark:focus:ring-stone-300",
    {
        variants: {
            variant: {
                default:
                    "border-transparent bg-stone-900 text-stone-50 hover:bg-stone-900/80 dark:bg-stone-50 dark:text-stone-900 dark:hover:bg-stone-50/80",
                secondary:
                    "border-transparent bg-stone-100 text-stone-900 hover:bg-stone-100/80 dark:bg-stone-800 dark:text-stone-50 dark:hover:bg-stone-800/80",
                destructive:
                    "border-transparent bg-error-500 text-stone-50 hover:bg-error-500/80 dark:bg-error-900 dark:text-stone-50 dark:hover:bg-error-900/80",
                outline: "text-stone-950 dark:text-stone-50",
                success: "border-transparent bg-green-50 text-green-600",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);

export type BadgeVariants = VariantProps<typeof badgeVariants>;
